import { render, staticRenderFns } from "./NewBadge.vue?vue&type=template&id=2933f080"
import script from "./NewBadge.vue?vue&type=script&lang=js"
export * from "./NewBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports